import React from 'react';
import { getFormattedNumber, getFormattedPercent } from '../../../../Util/numberFormats';
import { getPageTypeLabel } from './utilsSunburst';
import styles from '../Sunburst.module.css';

const LegendItem: React.FC<{
	onClick?: (item: any) => void
	item: any,
	totalLevel1Sessions: number,
	isTunnel?: boolean,
	children?: React.ReactNode,
	isClickable?: boolean
}> = ({
	onClick,
	item,
	totalLevel1Sessions,
	isTunnel = false,
	children,
	isClickable = false
}) => {

	const isFirstDepthElement =  item.depth === 1;
	const isExit = item.name === 'Site exit' || item.name === 'LostSession';
	const labelProportion = isFirstDepthElement ? 'of landing pages' : 'of previous step';
	const sessionValue = item.data?.sessionCount;

	const cssClass:string[] = [];

	if (isTunnel) {
		cssClass.push(styles.tunnelItem);
		if (isClickable) {
			cssClass.push(styles.tunnelItem_clickable);
		}
	} else {
		cssClass.push(styles.legendItem);
		if (isClickable) {
			cssClass.push(styles.legendItem_clickable);
		}
	}

	const getProportion = () => {
		if (typeof sessionValue !== 'number') {
			return 0;
		}

		if (item.depth === 1) {
			if (!totalLevel1Sessions) {
				return 0;
			}
			return ((sessionValue / totalLevel1Sessions) * 100);
		}

		if (typeof item.data.sessionCountProportionByParent === 'number') {
			return item.data.sessionCountProportionByParent;
		}

		if (isExit && item.node && item.node.parent) {
			const parentSessionCount = item.node.parent.data.sessionCount ?? item.node.parent.value;
			if (parentSessionCount) {
				return (sessionValue / parentSessionCount) * 100;
			}
		}

		return 0;
	};

	return (
		<div className={cssClass.join(' ')} onClick={onClick}>
			<div className={styles.legendItem_inner}>
				<div className='flex'>
					<div className='flex_item_fix'>
						<span className={styles.legend_item_color} style={{backgroundColor: isExit ? '#CACCD8' : item.color}}></span>
					</div>
					<div className={styles.legend_item_label}>
						{isTunnel && 
							<>{item.depth}.&nbsp;</>
						}
						{getPageTypeLabel(item.name)}
					</div>
				</div>
				<div className={styles.legend_item_values}>
					<div className='grey_2 s_14'>
						{getFormattedNumber(sessionValue)} sessions
						<span className='dot'></span>
						{getFormattedPercent(getProportion())} {labelProportion}
					</div>
				</div>
				{children}
			</div>
		</div>
	);
};

export default LegendItem;
